import React, { useState } from "react";
import "../static/css/Contact.css";

function Contact() {
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phoneNumber) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phoneNumber.replace(/\s/g, ""));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });

    // Validation
    if (!name.trim() || !mail.trim() || !phone.trim()) {
      setMessage({ type: "error", text: "All fields are required" });
      return;
    }

    if (!validateEmail(mail)) {
      setMessage({ type: "error", text: "Please enter a valid email address" });
      return;
    }

    if (!validatePhone(phone)) {
      setMessage({ type: "error", text: "Please enter a valid 10-digit phone number" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://backend.skpandco.in/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name.trim(),
          email: mail.trim(),
          phone: phone.trim(),
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage({ type: "success", text: data.message });
        // Clear form fields
        setName("");
        setMail("");
        setPhone("");
      } else {
        setMessage({ type: "error", text: data.message || "Failed to submit form" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage({ 
        type: "error", 
        text: "Unable to connect to server. Please try again later." 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="contact-container">
        <div className="contact-box">
          <div className="contact-address">
            <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3912.6841234567!2d76.95571899414062!3d11.005874633789062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDAwJzIxLjEiTiA3NsKwNTcnMjAuNiJF!5e0!3m2!1sen!2sin!4v1737900000000!5m2!1sen!2sin"></iframe>
            <p>
              CENTRAL OFFICE <br />
              849/2, 2nd floor, Mettupalayam Road,
              <br />
              Poo Market,
              <br />
              Coimbatore – 641002. <br />
              <br />
              +91 9787597500 ; info@skpandco.in
            </p>
          </div>
          <div className="vl"></div>
          <div className="contact-connect">
            <h4>Connect with Us</h4>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={loading}
                autoComplete="name"
              />
              <input
                type="email"
                placeholder="Email"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                disabled={loading}
                autoComplete="email"
              />
              <input
                type="tel"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={loading}
                autoComplete="tel"
              />
              
              {message.text && (
                <div className={`message ${message.type}`}>
                  {message.text}
                </div>
              )}
              
              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;

